export default __webpack_public_path__ + "static/kds-presentation-0d4562a6eb1cc7ce3dfe8b8e1a54c50c.png";